import React from 'react';

import { ThemeProvider } from 'styled-components';
import { THEME_DARK, THEME_DEFAULT } from '../../../theme/theme';

import {
	Container,
	Content,
	ContentWrapper,
	Description,
	Label, Title,
	Wrapper,
} from './hero.styles';

const Hero = ({
	title, label, description, dark, isWithImage
}) => {
	let theme = THEME_DEFAULT;
	if (dark) {
		theme = THEME_DARK;
	}

	return (
		<ThemeProvider theme={theme}>
			<Container isWithImage={isWithImage}>
				<Wrapper>
					<ContentWrapper>
						<Content>
							<Label>{label}</Label>
							<Title>{title}</Title>
							{description && <Description>{description}</Description>}
						</Content>
					</ContentWrapper>
				</Wrapper>
			</Container>
		</ThemeProvider>
	);
};

export default Hero;
